export default __webpack_public_path__ + "static/media/arrow.6278559b.svg";